import { PayloadAction } from '@reduxjs/toolkit';

import { SidebarState } from 'editor/src/store/editorModules/sidebar/types';

const setSidebarVisibleReducer = (state: SidebarState, action: PayloadAction<boolean>) => {
  state.isVisible = action.payload;
};

export default setSidebarVisibleReducer;
